import Util from './Util';


export default class ResponsiveBagProductDecider {
  constructor(bagObject) {
    this.bagObject = bagObject;
  }

  getZoneAData() {
    const productDetail = this.lastItemFromCurrentBag();
    if (productDetail) {
      productDetail.productIds = this.allProductIdsFromCurrentBag();
      return productDetail;
    }
    return undefined;
  }

  getZoneBData() {
    const productDetail = ResponsiveBagProductDecider.lastRecentlyViewedItem() || this.lastItemFromCurrentBag();
    if (productDetail) {
      productDetail.productIds = this.allProductIdsFromCurrentBag();
      return productDetail;
    }
    return undefined;
  }

  getBagZoneCData() {
    return this.unavailableItemsFromCurrentBag();
  }

  getSavedZoneCData() {
    return this.unavailableItemsFromSavedItems();
  }

  unavailableItemsFromCurrentBag() {
    const items = ResponsiveBagProductDecider.userAddedItemsOnly(this.bagObject.sections.bagItems.items);
    const unavailableItems = [];
    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i += 1) {
        if (items[i].flags.unavailableItem) {
          unavailableItems.push(ResponsiveBagProductDecider.productDetail(items[i]));
        }
      }
    }
    return unavailableItems.length > 0 ? unavailableItems : [];
  }

  unavailableItemsFromSavedItems() {
    const { savedItems } = this.bagObject.sections;
    const unavailableItems = [];
    if (savedItems) {
      const items = ResponsiveBagProductDecider.userAddedItemsOnly(savedItems.items);
      if (items && items.length > 0) {
        for (let i = 0; i < items.length; i += 1) {
          if (items[i].flags.unavailableItem) {
            unavailableItems.push(ResponsiveBagProductDecider.productDetail(items[i]));
          }
        }
      }
    }
    return unavailableItems.length > 0 ? unavailableItems : [];
  }


  lastItemFromCurrentBag() {
    const items = ResponsiveBagProductDecider.userAddedItemsOnly(this.bagObject.sections.bagItems.items);
    if (items && items.length > 0) {
      return ResponsiveBagProductDecider.productDetail(items[items.length - 1]);
    }
    return undefined;
  }

  allProductIdsFromCurrentBag() {
    if (this.bagObject.sections.bagItems) {
      const items = ResponsiveBagProductDecider.userAddedItemsOnly(this.bagObject.sections.bagItems.items);
      if (items && items.length > 0) {
        return items.map(x => x.productId).join('|');
      }
    }
    return undefined;
  }

  emptyCart() {
    if (!this.bagObject || !this.bagObject.sections) { return false; }

    const { bagItems, savedItems } = this.bagObject && this.bagObject.sections;
    return (!bagItems.items || bagItems.items.length === 0)
        && (!savedItems || !savedItems.items || savedItems.items.length === 0);
  }

  static lastRecentlyViewedItem() {
    const recentlyViewProducts = Util.getRecentlyViewedItems();
    if (recentlyViewProducts.length > 0) {
      return { productId: recentlyViewProducts[0] };
    }

    return undefined;
  }

  static productDetail(item) {
    const { defaultCategoryId, name } = item.product.detail;
    return { productId: item.productId, categoryId: defaultCategoryId, name };
  }

  static userAddedItemsOnly(items) {
    if (items && items.length > 0) {
      return items.filter(x => x.gwpPromotionId === 0);
    }
    return undefined;
  }
}
